import ReportDetailsHeader from 'Components/ReportDetailsHeader';
import React from 'react';
import { Card, CardHeader, Col, Row, TabContent, TabPane } from 'reactstrap';
import { EventPrecedence, ReportingTypeConstant } from 'shared/constants';
import AnchorageDetailsComponent from './partials/AnchorageDetailsComponent';
import PilotDetailsComponent from './partials/PilotDetailsComponent';
import TugsUsageComponent from './partials/TugsUsageComponent';
import OtherDetailsComponent from './partials/OtherDetailsComponent';
import PortActivitiesComponent from './partials/PortActivitiesComponent';
import { useDocumentTitle } from 'Components/useDocument.hooks';
import { RootState } from 'index';
import { useSelector } from 'react-redux';
import { checkValidObject } from 'GenericForms/Helper';

interface LfondsAddInformationType {
    activeTab: number,
    toggleTab: any,
    setErrorMessage: (value: boolean) => void,
    activeAddLfondsTab: number,
    toggleAddLfondsTab: (value: number) => void,
    editReportBool: boolean
}

const LfondsAddInformation = ({
    activeTab,
    toggleTab,
    setErrorMessage,
    activeAddLfondsTab,
    toggleAddLfondsTab,
    editReportBool
}: LfondsAddInformationType) => {
    /** State variables start*/
    useDocumentTitle('Lfonds Additional Information - ecoSAIL');
    const { CurrentReport } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    /** State variables end*/

    /** Functions to determine tab ids based on visibility */
    const AnchorageDetailsTabId = () => {
        if (checkValidObject(currentVesselReport)) {
            if (
                currentVesselReport?.event_precedence_id === EventPrecedence.DROP_ANCHOR ||
                currentVesselReport?.event_precedence_id === EventPrecedence.HEAVE_ANCHOR
            ) {
                return 1;
            }
        }
        return 0;
    }

    const PilotDetailsTabId = () => {
        if (checkValidObject(currentVesselReport)) {
            if (
                currentVesselReport?.event_precedence_id === EventPrecedence.DROP_ANCHOR ||
                currentVesselReport?.event_precedence_id === EventPrecedence.HEAVE_ANCHOR
            ) {
                return 2;
            } else if (currentVesselReport?.reporting_type === ReportingTypeConstant.INPORT) {
                return 1;
            }
        }
        return 0;
    }

    const TugsUsageTabId = () => {
        if (checkValidObject(currentVesselReport)) {
            if (
                currentVesselReport?.event_precedence_id === EventPrecedence.DROP_ANCHOR ||
                currentVesselReport?.event_precedence_id === EventPrecedence.HEAVE_ANCHOR
            ) {
                return 3;
            } else if (currentVesselReport?.reporting_type === ReportingTypeConstant.INPORT) {
                return 2;
            }
        }
        return 0;
    }

    const PortActivitiesTabId = () => {
        if (checkValidObject(currentVesselReport)) {
            if (currentVesselReport?.event_precedence_id === EventPrecedence.HEAVE_ANCHOR) {
                return 4;
            } else if (
                currentVesselReport?.event_precedence_id === EventPrecedence.DEPARTURE_FROM_DRIFTING_PORT ||
                currentVesselReport?.event_precedence_id === EventPrecedence.DEPARTURE_FROM_BERTH
            ) {
                return 3;
            } else if (
                currentVesselReport?.event_precedence_id === EventPrecedence.DEPARTURE_FROM_DRIFTING_SEA ||
                currentVesselReport?.event_precedence_id === EventPrecedence.BEGINNING_OF_SEA_PASSAGE
            ) {
                return 1;
            }
        }
        return 0;
    }

    const OtherDetailsTabId = () => {
        if (checkValidObject(currentVesselReport)) {
            if (currentVesselReport?.event_precedence_id === EventPrecedence.HEAVE_ANCHOR) {
                return 5;
            } else if (
                currentVesselReport?.event_precedence_id === EventPrecedence.DROP_ANCHOR ||
                currentVesselReport?.event_precedence_id === EventPrecedence.DEPARTURE_FROM_DRIFTING_PORT ||
                currentVesselReport?.event_precedence_id === EventPrecedence.DEPARTURE_FROM_BERTH
            ) {
                return 4;
            } else if (
                currentVesselReport?.reporting_type === ReportingTypeConstant.INPORT) {
                return 3;
            } else if (
                (currentVesselReport?.event_precedence_id === EventPrecedence.DEPARTURE_FROM_DRIFTING_SEA ||
                    currentVesselReport?.event_precedence_id === EventPrecedence.BEGINNING_OF_SEA_PASSAGE)
            ) {
                return 2;
            } else {
                return 1;
            }
        }
        return 0;
    }
    /** Tab id functions end */
    return (
        <Card className='deck-card-body mb-0 border-0'>
            <CardHeader className='px-0 py-2'>
                <div className="text-center">
                    <Row>
                        <Col>
                            <h4 className="page_title pos-start mb-0">Additional Information</h4>
                            <p className="card-title-desc pos-start">All readings since last report</p>
                        </Col>
                        <Col>
                            <ReportDetailsHeader />
                        </Col>
                    </Row>
                </div>
            </CardHeader>
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
                <TabContent activeTab={activeAddLfondsTab}>
                    <TabPane tabId={AnchorageDetailsTabId()}>
                        <AnchorageDetailsComponent
                            toggleTab={toggleTab}
                            activeTab={activeTab}
                            activeAddTab={activeAddLfondsTab}
                            toggleAddTab={toggleAddLfondsTab}
                            setErrorMessage={setErrorMessage}
                            editReportBool={editReportBool}
                        />
                    </TabPane>
                    <TabPane tabId={PilotDetailsTabId()}>
                        <PilotDetailsComponent
                            activeAddTab={activeAddLfondsTab}
                            toggleAddTab={toggleAddLfondsTab}
                            activeTab={activeTab}
                            toggleTab={toggleTab}
                            setErrorMessage={setErrorMessage}
                            editReportBool={editReportBool}
                        />
                    </TabPane>
                    <TabPane tabId={TugsUsageTabId()}>
                        <TugsUsageComponent
                            activeAddTab={activeAddLfondsTab}
                            toggleAddTab={toggleAddLfondsTab}
                            setErrorMessage={setErrorMessage}
                            editReportBool={editReportBool}
                        />
                    </TabPane>
                    <TabPane tabId={PortActivitiesTabId()}>
                        <PortActivitiesComponent
                            activeAddTab={activeAddLfondsTab}
                            toggleAddTab={toggleAddLfondsTab}
                            setErrorMessage={setErrorMessage}
                            toggleTab={toggleTab}
                            activeTab={activeTab}
                            editReportBool={editReportBool}
                        />
                    </TabPane>
                    <TabPane tabId={OtherDetailsTabId()}>
                        <OtherDetailsComponent
                            activeTab={activeTab}
                            toggleTab={toggleTab}
                            setErrorMessage={setErrorMessage}
                            editReportBool={editReportBool}
                            toggleAddTab={toggleAddLfondsTab}
                            activeAddTab={activeAddLfondsTab}
                        />
                    </TabPane>
                </TabContent>
            </div>
        </Card>
    )
}

export default LfondsAddInformation